/* ==========================================================================
   product-details-upper.js
   Behaviour for snippets/product-details-upper.liquid:
   gallery slider, zoom, variant selection, quantity, buy now, wishlist/share.
   Self-contained IIFE — safe to load with or without the lower module.
   ========================================================================== */
(function () {
  'use strict';

  function initUpper(root) {
    if (!root || root.dataset.pduInit === 'true') return;
    root.dataset.pduInit = 'true';

    /* ---------------- Gallery ---------------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdu-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdu-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdu-dot]'));
    var stage = root.querySelector('.pdu__stage');
    var index = 0;

    function goTo(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === index);
        t.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
      if (stage) stage.classList.remove('is-zoomed');
    }

    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.pduThumb)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(Number(d.dataset.pduDot)); }); });

    var prev = root.querySelector('[data-pdu-prev]');
    var next = root.querySelector('[data-pdu-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var zoomBtn = root.querySelector('[data-pdu-zoom]');
    if (zoomBtn && stage) {
      zoomBtn.addEventListener('click', function () { stage.classList.toggle('is-zoomed'); });
      stage.addEventListener('click', function (e) {
        if (stage.classList.contains('is-zoomed') && e.target.tagName === 'IMG') stage.classList.remove('is-zoomed');
      });
    }

    // Touch swipe on the stage.
    if (stage) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? index + 1 : index - 1);
        startX = null;
      });
    }

    /* ---------------- Variants ---------------- */
    var dataEl = root.querySelector('[data-pdu-variants]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent) || []; } catch (err) { variants = []; } }

    var idInput = root.querySelector('[data-pdu-variant-id]');
    var priceEl = root.querySelector('[data-pdu-price]');
    var addBtn = root.querySelector('.pdu__btn--cart');

    function currentOptions() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-pdu-option]:checked'))
        .map(function (i) { return i.value; });
    }

    function matchVariant() {
      var opts = currentOptions();
      if (!opts.length) return null;
      return variants.filter(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      })[0] || null;
    }

    function updateVariant() {
      var variant = matchVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (addBtn.dataset.label || addBtn.textContent) : 'SOLD OUT';
      }
      if (priceEl && window.Shopify && window.Shopify.formatMoney) {
        var cur = priceEl.querySelector('.pdu__price-current');
        var was = priceEl.querySelector('.pdu__price-was');
        if (cur) cur.textContent = window.Shopify.formatMoney(variant.price);
        if (was) was.textContent = variant.compare_at_price ? window.Shopify.formatMoney(variant.compare_at_price) : '';
      }
      // Keep the URL shareable / refresh-safe.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      // Reflect the variant image in the gallery when one is assigned.
      if (variant.featured_media && variant.featured_media.position) goTo(variant.featured_media.position - 1);
    }

    if (addBtn) addBtn.dataset.label = addBtn.textContent.trim();
    root.querySelectorAll('[data-pdu-option]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    /* ---------------- Quantity ---------------- */
    var qtyWrap = root.querySelector('[data-pdu-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('input');
      qtyWrap.querySelector('[data-pdu-qty-minus]').addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      qtyWrap.querySelector('[data-pdu-qty-plus]').addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    /* ---------------- Buy now ---------------- */
    var buyNow = root.querySelector('[data-pdu-buy-now]');
    var form = root.querySelector('.pdu__form');
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Buy it now';
        form.appendChild(checkoutInput);
        form.submit();
      });
    }

    /* ---------------- Wishlist / compare / share ---------------- */
    function toggleStored(key, value, button) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (err) { list = []; }
      var at = list.indexOf(value);
      if (at > -1) { list.splice(at, 1); } else { list.push(value); }
      localStorage.setItem(key, JSON.stringify(list));
      button.classList.toggle('is-active', at === -1);
    }

    var wishlist = root.querySelector('[data-pdu-wishlist]');
    if (wishlist) {
      var wid = wishlist.dataset.productId;
      try {
        if ((JSON.parse(localStorage.getItem('kefit:wishlist') || '[]')).indexOf(wid) > -1) wishlist.classList.add('is-active');
      } catch (err) {}
      wishlist.addEventListener('click', function () { toggleStored('kefit:wishlist', wid, wishlist); });
    }

    var compare = root.querySelector('[data-pdu-compare]');
    if (compare) {
      compare.addEventListener('click', function () { toggleStored('kefit:compare', compare.dataset.productHandle, compare); });
    }

    var share = root.querySelector('[data-pdu-share]');
    if (share) {
      share.addEventListener('click', function () {
        var payload = { title: share.dataset.shareTitle, url: share.dataset.shareUrl };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(payload.url);
          share.classList.add('is-active');
          setTimeout(function () { share.classList.remove('is-active'); }, 1500);
        }
      });
    }

    goTo(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pdu]').forEach(initUpper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
/* ==========================================================================
   product-details-upper.js
   Behaviour for snippets/product-details-upper.liquid:
   gallery slider, zoom, variant selection, quantity, buy now, wishlist/share.
   Self-contained IIFE — safe to load with or without the lower module.
   ========================================================================== */
(function () {
  'use strict';

  function initUpper(root) {
    if (!root || root.dataset.pduInit === 'true') return;
    root.dataset.pduInit = 'true';

    /* ---------------- Gallery ---------------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdu-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdu-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdu-dot]'));
    var stage = root.querySelector('.pdu__stage');
    var index = 0;

    function goTo(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === index);
        t.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      if (stage) stage.classList.remove('is-zoomed');
    }

    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.dataset.pduThumb)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(Number(d.dataset.pduDot)); }); });

    var prev = root.querySelector('[data-pdu-prev]');
    var next = root.querySelector('[data-pdu-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    var zoomBtn = root.querySelector('[data-pdu-zoom]');
    if (zoomBtn && stage) {
      zoomBtn.addEventListener('click', function () { stage.classList.toggle('is-zoomed'); });
      stage.addEventListener('click', function (e) {
        if (stage.classList.contains('is-zoomed') && e.target.tagName === 'IMG') stage.classList.remove('is-zoomed');
      });
    }

    // Touch swipe on the stage.
    if (stage) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? index + 1 : index - 1);
        startX = null;
      });
    }

    /* ---------------- Variants ---------------- */
    var dataEl = root.querySelector('[data-pdu-variants]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent) || []; } catch (err) { variants = []; } }

    var idInput = root.querySelector('[data-pdu-variant-id]');
    var priceEl = root.querySelector('[data-pdu-price]');
    var addBtn = root.querySelector('.pdu__btn--cart');

    function currentOptions() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-pdu-option]:checked'))
        .map(function (i) { return i.value; });
    }

    function matchVariant() {
      var opts = currentOptions();
      if (!opts.length) return null;
      return variants.filter(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      })[0] || null;
    }

    // Price text for a variant.
    // When the page shows the AED symbol, only the number is written (the symbol stays in the page).
    function priceText(cents, aedMode) {
      if (!window.Shopify || !window.Shopify.formatMoney) return null;
      if (aedMode) {
        return window.Shopify.formatMoney(cents, '{{amount}}').replace(/[.,]00$/, '');
      }
      return window.Shopify.formatMoney(cents);
    }

    function updateVariant() {
      var variant = matchVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? (addBtn.dataset.label || addBtn.textContent) : 'SOLD OUT';
      }
      if (priceEl) {
        var aedMode = priceEl.getAttribute('data-pdu-aed') === 'true';
        var cur = priceEl.querySelector('.pdu__price-num') || priceEl.querySelector('.pdu__price-current');
        var was = priceEl.querySelector('.pdu__price-was');
        var curText = priceText(variant.price, aedMode);
        if (cur && curText !== null) cur.textContent = curText;
        if (was) {
          var wasText = variant.compare_at_price ? priceText(variant.compare_at_price, aedMode) : '';
          if (wasText !== null) was.textContent = wasText;
        }
      }
      // Keep the URL shareable / refresh-safe.
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      // Reflect the variant image in the gallery when one is assigned.
      if (variant.featured_media && variant.featured_media.position) goTo(variant.featured_media.position - 1);
    }

    if (addBtn) addBtn.dataset.label = addBtn.textContent.trim();
    root.querySelectorAll('[data-pdu-option]').forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    /* ---------------- Quantity ---------------- */
    var qtyWrap = root.querySelector('[data-pdu-qty]');
    if (qtyWrap) {
      var qtyInput = qtyWrap.querySelector('input');
      qtyWrap.querySelector('[data-pdu-qty-minus]').addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      });
      qtyWrap.querySelector('[data-pdu-qty-plus]').addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });
    }

    /* ---------------- Buy now ---------------- */
    var buyNow = root.querySelector('[data-pdu-buy-now]');
    var form = root.querySelector('.pdu__form');
    if (buyNow && form) {
      buyNow.addEventListener('click', function () {
        var checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Buy it now';
        form.appendChild(checkoutInput);
        form.submit();
      });
    }

    /* ---------------- Wishlist / compare / share ---------------- */
    function toggleStored(key, value, button) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem(key) || '[]'); } catch (err) { list = []; }
      var at = list.indexOf(value);
      if (at > -1) { list.splice(at, 1); } else { list.push(value); }
      localStorage.setItem(key, JSON.stringify(list));
      button.classList.toggle('is-active', at === -1);
    }

    var wishlist = root.querySelector('[data-pdu-wishlist]');
    if (wishlist) {
      var wid = wishlist.dataset.productId;
      try {
        if ((JSON.parse(localStorage.getItem('kefit:wishlist') || '[]')).indexOf(wid) > -1) wishlist.classList.add('is-active');
      } catch (err) {}
      wishlist.addEventListener('click', function () { toggleStored('kefit:wishlist', wid, wishlist); });
    }

    var compare = root.querySelector('[data-pdu-compare]');
    if (compare) {
      compare.addEventListener('click', function () { toggleStored('kefit:compare', compare.dataset.productHandle, compare); });
    }

    var share = root.querySelector('[data-pdu-share]');
    if (share) {
      share.addEventListener('click', function () {
        var payload = { title: share.dataset.shareTitle, url: share.dataset.shareUrl };
        if (navigator.share) {
          navigator.share(payload).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(payload.url);
          share.classList.add('is-active');
          setTimeout(function () { share.classList.remove('is-active'); }, 1500);
        }
      });
    }

    goTo(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-pdu]').forEach(initUpper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();